module.exports = __webpack_public_path__ + "img/icon_map_dian_zaixian.f1a63286.svg";